<template>
	<OrganismDialogAppointment
		:key="`appointment-dialog-${isApplyDialogOpen}`"
		:is-open="isApplyDialogOpen"
		@close="closeDialog"
	/>
	<OrganismMainMenuMobile
		class="lg:hidden"
		:is-open="isMobileMenuOpen"
		:phone-link="phoneLink"
		:menu-items="mainMenuItems('mobile')"
		:service-menu-items="menuServiceItems"
		@close="closeMobileMenu"
		@click-appointment-button="openAppointmentDialog"
	/>
	<OrganismDialogContact
		:is-open="isContactDialogOpen"
		@close="closeDialog"
	/>
	<OrganismDialogCookieConsent />
</template>

<script lang="ts" setup>
import { phoneLink } from '#fysio/core/consts/links';
import menuServiceItems from '#fysio/core/consts/menuServiceItems';

const {
	isApplyDialogOpen,
	openAppointmentDialog,
	isContactDialogOpen,
	closeDialog,
	isMobileMenuOpen,
	closeMobileMenu,
} = useDialogs();
</script>
